/** Interfaces */
import { BydRhsApiConfigInterface } from '../interfaces/byd-rhs-api-config.interface';

export class BydRhsConfig implements BydRhsApiConfigInterface {
  /**
   * The byd roazhon service api `base url`
   */
  apiUrl: string;

  /**
   * The byd roazhon service api `scope`
   */
  apiScope: string;

  /**
   * Creates an instance of BydRhsConfig.
   *
   * @param jsonObject the api settings
   * @memberof BydRhsConfig
   */
  constructor(jsonObject: BydRhsApiConfigInterface) {
    this.apiUrl = jsonObject.apiUrl;
    this.apiScope = jsonObject.apiScope;
  }
}
